export const earnContractABI = [
  {
      "inputs":[
          {
              "internalType":"address",
              "name":"_token",
              "type":"address"
          },
          {
              "internalType":"uint256",
              "name":"_earnLowerlimit",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"constructor"
  },
  {
      "anonymous":false,
      "inputs":[
          {
              "indexed":true,
              "internalType":"address",
              "name":"owner",
              "type":"address"
          },
          {
              "indexed":true,
              "internalType":"address",
              "name":"spender",
              "type":"address"
          },
          {
              "indexed":false,
              "internalType":"uint256",
              "name":"value",
              "type":"uint256"
          }
      ],
      "name":"Approval",
      "type":"event"
  },
  {
      "anonymous":false,
      "inputs":[
          {
              "indexed":true,
              "internalType":"address",
              "name":"from",
              "type":"address"
          },
          {
              "indexed":true,
              "internalType":"address",
              "name":"to",
              "type":"address"
          },
          {
              "indexed":false,
              "internalType":"uint256",
              "name":"value",
              "type":"uint256"
          }
      ],
      "name":"Transfer",
      "type":"event"
  },
  {
      "payable":true,
      "stateMutability":"payable",
      "type":"fallback"
  },
  {
      "constant":true,
      "inputs":[
          {
              "internalType":"address",
              "name":"owner",
              "type":"address"
          },
          {
              "internalType":"address",
              "name":"spender",
              "type":"address"
          }
      ],
      "name":"allowance",
      "outputs":[
          {
              "internalType":"uint256",
              "name":"",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"address",
              "name":"spender",
              "type":"address"
          },
          {
              "internalType":"uint256",
              "name":"amount",
              "type":"uint256"
          }
      ],
      "name":"approve",
      "outputs":[
          {
              "internalType":"bool",
              "name":"",
              "type":"bool"
          }
      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"available",
      "outputs":[
          {
              "internalType":"uint256",
              "name":"",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"balance",
      "outputs":[
          {
              "internalType":"uint256",
              "name":"",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[
          {
              "internalType":"address",
              "name":"account",
              "type":"address"
          }
      ],
      "name":"balanceOf",
      "outputs":[
          {
              "internalType":"uint256",
              "name":"",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"controller",
      "outputs":[
          {
              "internalType":"address",
              "name":"",
              "type":"address"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"decimals",
      "outputs":[
          {
              "internalType":"uint8",
              "name":"",
              "type":"uint8"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"address",
              "name":"spender",
              "type":"address"
          },
          {
              "internalType":"uint256",
              "name":"subtractedValue",
              "type":"uint256"
          }
      ],
      "name":"decreaseAllowance",
      "outputs":[
          {
              "internalType":"bool",
              "name":"",
              "type":"bool"
          }
      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"uint256",
              "name":"_amount",
              "type":"uint256"
          }
      ],
      "name":"deposit",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"depositAll",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"depositETH",
      "outputs":[

      ],
      "payable":true,
      "stateMutability":"payable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"uint256",
              "name":"_amount",
              "type":"uint256"
          }
      ],
      "name":"depositToken0",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"depositToken0All",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"uint256",
              "name":"_amount",
              "type":"uint256"
          }
      ],
      "name":"depositToken1",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"depositToken1All",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"doApprove",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"earn",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"earnLowerlimit",
      "outputs":[
          {
              "internalType":"uint256",
              "name":"",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"getPricePerFullShare",
      "outputs":[
          {
              "internalType":"uint256",
              "name":"",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"governance",
      "outputs":[
          {
              "internalType":"address",
              "name":"",
              "type":"address"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"address",
              "name":"spender",
              "type":"address"
          },
          {
              "internalType":"uint256",
              "name":"addedValue",
              "type":"uint256"
          }
      ],
      "name":"increaseAllowance",
      "outputs":[
          {
              "internalType":"bool",
              "name":"",
              "type":"bool"
          }
      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"max",
      "outputs":[
          {
              "internalType":"uint256",
              "name":"",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"min",
      "outputs":[
          {
              "internalType":"uint256",
              "name":"",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"name",
      "outputs":[
          {
              "internalType":"string",
              "name":"",
              "type":"string"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"address",
              "name":"_controller",
              "type":"address"
          }
      ],
      "name":"setController",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"uint256",
              "name":"_earnLowerlimit",
              "type":"uint256"
          }
      ],
      "name":"setEarnLowerlimit",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"address",
              "name":"_governance",
              "type":"address"
          }
      ],
      "name":"setGovernance",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"uint256",
              "name":"_min",
              "type":"uint256"
          }
      ],
      "name":"setMin",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"symbol",
      "outputs":[
          {
              "internalType":"string",
              "name":"",
              "type":"string"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"token",
      "outputs":[
          {
              "internalType":"contract IERC20",
              "name":"",
              "type":"address"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"token0",
      "outputs":[
          {
              "internalType":"address",
              "name":"",
              "type":"address"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"token1",
      "outputs":[
          {
              "internalType":"address",
              "name":"",
              "type":"address"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"totalSupply",
      "outputs":[
          {
              "internalType":"uint256",
              "name":"",
              "type":"uint256"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"address",
              "name":"recipient",
              "type":"address"
          },
          {
              "internalType":"uint256",
              "name":"amount",
              "type":"uint256"
          }
      ],
      "name":"transfer",
      "outputs":[
          {
              "internalType":"bool",
              "name":"",
              "type":"bool"
          }
      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"address",
              "name":"sender",
              "type":"address"
          },
          {
              "internalType":"address",
              "name":"recipient",
              "type":"address"
          },
          {
              "internalType":"uint256",
              "name":"amount",
              "type":"uint256"
          }
      ],
      "name":"transferFrom",
      "outputs":[
          {
              "internalType":"bool",
              "name":"",
              "type":"bool"
          }
      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"unihelper",
      "outputs":[
          {
              "internalType":"address",
              "name":"",
              "type":"address"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"unirouter",
      "outputs":[
          {
              "internalType":"address",
              "name":"",
              "type":"address"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":true,
      "inputs":[

      ],
      "name":"weth",
      "outputs":[
          {
              "internalType":"address",
              "name":"",
              "type":"address"
          }
      ],
      "payable":false,
      "stateMutability":"view",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"uint256",
              "name":"_shares",
              "type":"uint256"
          }
      ],
      "name":"withdraw",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"withdrawAll",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"uint256",
              "name":"_shares",
              "type":"uint256"
          }
      ],
      "name":"withdrawETH",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"withdrawETHAll",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"uint256",
              "name":"_shares",
              "type":"uint256"
          }
      ],
      "name":"withdrawToken0",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"withdrawToken0All",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[
          {
              "internalType":"uint256",
              "name":"_shares",
              "type":"uint256"
          }
      ],
      "name":"withdrawToken1",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
      "constant":false,
      "inputs":[

      ],
      "name":"withdrawToken1All",
      "outputs":[

      ],
      "payable":false,
      "stateMutability":"nonpayable",
      "type":"function"
  },
  {
		"inputs": [],
		"name": "_uniswapV2FactoryAddress",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "_uniswapV2Router02Address",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "out_token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "liquidity",
				"type": "uint256"
			}
		],
		"name": "out",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
]